import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { ReportsService } from 'libs/data/src/lib/services/report/reports.service';
import { emailRegex, ShareReportUserType } from 'libs/shared/src/lib/constants';
import { CustomModalService } from 'libs/shared/src/lib/modal/custom-modal.service';
import { teamIcn, memberIcn, emailIcn, TreeNode } from 'libs/shared/src/lib/constants';
import {
  MEMBERS_LOADING_MESSAGE,
  TEAMS_LOADING_MESSAGE,
} from 'libs/shared/src/lib/constants/loader-messages';

@Component({
  selector: 'piqet-angular-report-share',
  templateUrl: './report-share.component.html',
  styleUrls: ['./report-share.component.scss'],
})
export class ReportShareComponent {
  @ViewChild('selectedContainer') selectedContainer!: ElementRef;
  @Output() exportOrShareReport = new EventEmitter<{ payload: any }>();
  ShareReportUserType = ShareReportUserType;
  teamIcn = teamIcn;
  memberIcn = memberIcn;
  emailIcn = emailIcn;
  activeTab: number = 1;
  filteredTeams: any = [];
  filteredMembers: any = [];
  searchTermTeams = '';
  searchTermMembers = '';
  selectedTeams: any[] = [];
  selectedMembers: any[] = [];
  gridApiMembers: any;
  gridApiTeams: any;
  members: any = [];
  teams: any = [];
  self: any;

  selectedItems: any[] = [];
  newEmail: string = '';
  emailError: string | null = null;
  isInlineLoader = false;
  teamLoadingMessage = TEAMS_LOADING_MESSAGE;
  memberLoadingMessage = MEMBERS_LOADING_MESSAGE;
  constructor(private modal: CustomModalService, private reportService: ReportsService) {}

  private static cachedTeamsAndMembers: any = null;

  async ngOnInit() {
    await this.GetTeamsAndActiveMembers();
  }

  onClose() {
    this.modal.close();
  }

  setActiveTab(tab: number) {
    this.activeTab = tab;
    this.removeFilter();
  }

  removeFilter() {
    this.searchTermTeams = '';
    this.searchTermMembers = '';
    this.filterTeams();
    this.filterMembers();
  }

  onSelectionChange(item: any, type: number) {
    item.checked = !item.checked;

    if (item.checked) {
      this.selectedItems.push({ ...item, type });
    } else {
      this.removeFromSelected(item.id, type);
    }
    this.scrollToBottom();
  }

  removeFromSelected(id: number, type: number) {
    this.selectedItems = this.selectedItems.filter(item => item.id !== id || item.type !== type);

    if (type === this.ShareReportUserType.Members) {
      const member = this.filteredMembers.find((m: { id: number }) => m.id === id);
      if (member) {
        member.checked = false;
      }
    } else if (type === this.ShareReportUserType.Teams) {
      const team = this.filteredTeams.find((t: { id: number }) => t.id === id);
      if (team) {
        team.checked = false;
      }
      team.members.forEach((member: { id: number }) => {
        const filteredMember = this.filteredMembers.find((m: { id: number }) => m.id === member.id);
        if (filteredMember) {
          filteredMember.checked = false;
          filteredMember.disabled = false;
        }
      });
    } else if (type === this.ShareReportUserType.Self) {
      this.self.checked = false;
    }
  }

  filterTeams() {
    const searchTerm = this.searchTermTeams.toLowerCase();
    this.filteredTeams = this.teams.filter(
      (team: { name: string; members: any[] }) =>
        team.name.toLowerCase().includes(searchTerm) ||
        team.members.some((member: { name: string }) =>
          member.name.toLowerCase().includes(searchTerm)
        )
    );
  }

  filterMembers() {
    const searchTerm = this.searchTermMembers.toLowerCase();
    this.filteredMembers = this.members.filter((member: { name: string }) =>
      member.name.toLowerCase().includes(searchTerm)
    );
  }

  onSelectionChanged(item: any, type: number) {
    if (item.checked) {
      item.checked = false;

      this.selectedItems = this.selectedItems.filter((selected: any) => selected.id !== item.id);

      if (type === this.ShareReportUserType.Teams) {
        item.members.forEach((member: { id: number }) => {
          const filteredMember = this.filteredMembers.find(
            (m: { id: number }) => m.id === member.id
          );
          if (filteredMember) {
            filteredMember.checked = false;
            filteredMember.disabled = false;
          }
        });
        this.selectedTeams = this.selectedTeams.filter((team: any) => team.id !== item.id);
      } else if (type === this.ShareReportUserType.Members) {
        this.selectedMembers = this.selectedMembers.filter((member: any) => member.id !== item.id);
      }
    } else {
      item.checked = true;

      const newItem = { ...item, type, checked: true };

      if (type === this.ShareReportUserType.Teams) {
        item.members.forEach((member: { id: number }) => {
          const filteredMember = this.filteredMembers.find(
            (m: { id: number }) => m.id === member.id
          );
          if (filteredMember) {
            filteredMember.checked = true;
            filteredMember.disabled = true;
            this.selectedItems = this.selectedItems.filter(
              (selected: any) => selected.id !== member.id
            );
          }
        });
        this.selectedTeams = [...this.selectedTeams, newItem];
      } else if (type === this.ShareReportUserType.Members) {
        this.selectedMembers = [...this.selectedMembers, newItem];
      }

      this.selectedItems = [...this.selectedItems, newItem];
      this.scrollToBottom();
    }
    this.removeFilter();
  }

  clearAllByType() {
    this.selectedItems = [];
    this.filteredTeams.forEach((node: { checked: boolean }) => {
      node.checked = false;
    });
    this.filteredMembers.forEach((node: { checked: boolean; disabled: boolean }) => {
      node.checked = false;
      node.disabled = false;
    });
    this.self.checked = false;
  }

  async GetTeamsAndActiveMembers() {
    this.isInlineLoader = true;

    // Use cached data if available to avoid slow API call on every modal open
    let teamsAndMembers = ReportShareComponent.cachedTeamsAndMembers;
    if (!teamsAndMembers) {
      teamsAndMembers = await this.reportService.getAllMyOrganizationTeamListAndUsers();
      ReportShareComponent.cachedTeamsAndMembers = teamsAndMembers;
    }

    this.teams = teamsAndMembers.data.teams.map((team: any) => {
      return { ...team, type: this.ShareReportUserType.Teams, checked: false, expanded: false };
    });
    this.members = teamsAndMembers.data.activeMembers.map((member: any) => {
      return { ...member, type: this.ShareReportUserType.Members };
    });
    this.self = {
      ...teamsAndMembers.data.self,
      type: this.ShareReportUserType.Self,
      checked: false,
    };
    this.isInlineLoader = false;
    this.filteredTeams = this.teams;
    this.filteredMembers = this.members;
  }

  sendMail() {
    const teams: any = this.selectedItems.filter(
      item => item.type == this.ShareReportUserType.Teams
    );
    const members: any = this.selectedItems.filter(
      item => item.type != this.ShareReportUserType.Teams
    );
    const propertiesToDelete = ['checked'];
    propertiesToDelete.forEach(prop => {
      members.forEach((member: any) => {
        if (prop in member) {
          delete member[prop];
        }
      });
    });

    const finalArray = teams.flatMap((team: any) => {
      return team.members.map((member: any) => {
        return {
          id: member.id,
          name: member.name,
          type: team.type,
        };
      });
    });

    const combinedArray = [...members, ...finalArray];

    this.exportOrShareReport.emit({ payload: combinedArray });
  }

  checkValidation() {
    this.emailError = null;
    if (!this.newEmail) {
      this.emailError = 'required';
      return;
    }

    const emailPattern = new RegExp(emailRegex);
    if (!emailPattern.test(this.newEmail)) {
      this.emailError = 'pattern';
      return;
    }

    if (this.selectedItems.some(item => item.name === this.newEmail)) {
      this.emailError = 'duplicate';
      return;
    }
  }

  addEmailToSelectedItems(): void {
    if (this.emailError == null && this.newEmail?.trim()) {
      const randomId = Math.random().toString(36).substr(2, 9);

      const newEmailObject = {
        id: randomId,
        name: this.newEmail.trim(),
        type: this.ShareReportUserType.Others,
        check: true,
      };

      this.selectedItems.push(newEmailObject);
      this.newEmail = '';
    }

    this.scrollToBottom();
  }

  toggleNode(node: TreeNode): void {
    node.checked = !node.checked;
  }

  toggleExpand(node: TreeNode): void {
    if (node.members) {
      this.filteredTeams.forEach((n: any) => {
        if (n !== node) {
          n.expanded = false;
        }
      });
      node.expanded = !node.expanded;
    }
  }
  scrollToBottom() {
    if (this.selectedContainer && this.selectedContainer.nativeElement) {
      this.selectedContainer.nativeElement.scrollTop =
        this.selectedContainer.nativeElement.scrollHeight;
    }
  }
}
